export default __webpack_public_path__ + "static/media/SMCLogo.c336a439.svg";